import React, { createContext, useContext, useEffect, useState } from 'react';
type CountdownValue = {
  secondsLeft: number;
  label: string;
};
const TOTAL_SECONDS = 30 * 60;
const CountdownContext = createContext<CountdownValue>({
  secondsLeft: TOTAL_SECONDS,
  label: '30:00'
});
function format(seconds: number): string {
  const safe = Math.max(seconds, 0);
  const minutes = Math.floor(safe / 60);
  const rest = safe % 60;
  return `${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
}
export function CountdownProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [secondsLeft, setSecondsLeft] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  return <CountdownContext.Provider value={{
    secondsLeft,
    label: format(secondsLeft)
  }} data-id="element-196" data-mp="21zxhqfiiek6x">
      {children}
    </CountdownContext.Provider>;
}
export function useCountdown(): CountdownValue {
  return useContext(CountdownContext);
}